exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bi-common-word-cloud svg g:focus[tabindex]{outline:2px solid #2d74da}", ""]);

// exports
